import React from 'react';
import ReactDOM from 'react-dom';
import SizeGuideContent from './SizeGuideContent';
import { getGenderAndCategoryData } from './utils';
import 'semantic-ui-css/components/transition.css';
import 'semantic-ui-css/components/flag.css';

const SizeGuideWebView = () => {
  return (
    <div className={`size-guide-sidebar`}>
      <div className="size-guide-header">
        <h4 className="h4 uppercase center pl-0">{`${titlePrefix} size guide`}</h4>
      </div>
      <SizeGuideContent gender={gender} category={category} subcategory={subcategory} quickFitText={quickFitText} />
    </div>
  );
};

export default SizeGuideWebView;

// @ts-expect-error
const { type: productType } = window.productData;
// @ts-expect-error
const quickFitText = window.quickFitText;
const { gender, titlePrefix, category, subcategory } = getGenderAndCategoryData(productType);

const mountNode = document.querySelector('[react-render-target="size-guide-webview"]');
mountNode ? ReactDOM.render(<SizeGuideWebView />, mountNode) : console.warn('missing render target: SizeGuideWebView');
